import { db } from '@/api/firebase';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useMainContext } from '@/context/main-context';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { useForm } from 'react-hook-form';

const AddRoomDialog = ({ open, setOpen }) => {
  const { uid, addRoom, activeBranchId } = useMainContext();
  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    if (!uid) return;

    const newRoom = {
      name: data.name,
      capacity: Number(data.capacity),
      branchId: activeBranchId,
      createdAt: serverTimestamp(),
      groups: [],
    };

    try {
      const roomsCol = collection(db, `users/${uid}/rooms`);
      const docRef = await addDoc(roomsCol, newRoom);

      addRoom({ id: docRef.id, ...newRoom });

      reset();
      setOpen(false);
    } catch (error) {
      console.error('Xona qo‘shishda xatolik:', error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Yangi xona qo‘shish</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <Label required htmlFor="name">
              Xona nomi
            </Label>
            <Input
              disabled={isSubmitting}
              id="name"
              {...register('name', { required: true })}
              placeholder="Xona #001"
            />
          </div>

          <div>
            <Label required htmlFor="capacity">
              Sig‘imi
            </Label>
            <Input
              disabled={isSubmitting}
              id="capacity"
              type="number"
              placeholder="Xona sig'imi: 25 ta"
              {...register('capacity', { required: true })}
            />
          </div>

          <div className="flex justify-end gap-2">
            <Button
              onClick={() => setOpen(false)}
              variant="secondary"
              type="button"
            >
              Bekor qilish
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Yuborilmoqda...' : 'Saqlash'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddRoomDialog;
